import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}

interface UsersInterface {
    customerid?: string;
    // CUSTOMER INTERFACE
    name: string;
    location: string;

    // ACTUAL USERS INTERFACE
    // username: string;
    // password: string;
    // company: string;
    // fullname: string;
    // email: string;
    // phone: string;
}

const defaultData = {
    // FOR CUSTOMER INTERFACE
    name: "",
    location: ""

    // FOR ACTUAL USERS INTERFACE
    // username: "",
    // password: "",
    // company: "",
    // fullname: "",
    // email: "",
    // phone: ""
}

const UsersAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([defaultData])
    const [input, setInput] = useState<UsersInterface>(defaultData)
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => { 
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/customer").then(res => {
            setLoading(false)
            console.log(118327, res.data.component)
        }).catch( err => {
            setLoading(false)
            console.log("[ERR]", err)
        })
        if (type==="edit" && id) { // (THIS SECTION IS FOR DISPLAYING CURRENT VALUES IN EACH INPUT WHEN UPDATING)
            getData(id)
        }
    }, [])


    if (type!=="add" && type!=="edit") { // WHAT IS THIS SECTION FOR?
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type==="add" && id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type==="edit" && !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }


    function getData(id:string):void { // THIS SECTION IS FOR DISPLAYING CURRENT VALUES IN EACH INPUT WHEN UPDATING
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/customer/${id}`).then(res => {
            setLoading(false)
            console.log(123, res)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(456, err)
            return <Navigate to="/" replace={true} />
        })
    }


    function handleSubmit() {
        // PUT VALIDATION IN SUBMIT
        if (type==="add") {
            console.log("add", input)

            if (!(input.name && input.location)) {
                return alert("Make sure all fields are filled")
            } else if (input.location.length < 8) { 
                return alert("Password must have at least 8 characters")
            } else {
                setLoading(true)
                axiosInstance.post('https://api.cl-ds.com/internal/operations/v1/customer/', input).then((res:any) =>{
                    setLoading(false)
                    alert(res.data.message)
                }).catch( err => {
                    setLoading(false)
                    console.log(3244, err)
                })

            }
        } else {
            console.log("edit", input)

            if (!(input.name && input.location)) {
                return alert("Make sure all fields are filled")
            } else if (input.location.length < 8) { 
                return alert("Password must have at least 8 characters")
            } else {
                setLoading(true)
                axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/customer/${id}/`, input).then((res:any) => {
                    setLoading(false)
                    alert(res.data.message)
                }).catch( err => {
                    setLoading(false)
                    console.log(3244, err)
                })

            }
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>, field: string) {
        console.log("handleChange", inputs)
        setInput(prev => ({
            ...prev,
            [field]: e.target.value
        }))
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">{type === "add" ? "Create" : "Edit"} User</h5>
                    {type === "add" &&
                        <div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Username</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.username} onChange={(e)=>handleChange(e, "username")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.pcba_name} onChange={(e)=>handleChange(e, "pcba_name")}/> */}
                                    <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Password</label>
                                <div className="col-sm-8 d-flex">
                                    {/* <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.password} onChange={(e)=>handleChange(e, "password")}/> */}
                                    {/* <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.type} onChange={(e)=>handleChange(e, "type")}/> */}
                                    {/* <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.mcuid} onChange={(e)=>handleChange(e, "mcuid")}/> */}
                                    <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.location} onChange={(e)=>handleChange(e, "location")}/>
                                    <button type="button" className="btn btn-outline-primary mx-1" onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                    </button>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Full Name</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.fullname} onChange={(e)=>handleChange(e, "fullname")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.supplier} onChange={(e)=>handleChange(e, "supplier")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.version} onChange={(e)=>handleChange(e, "version")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Email</label>
                                <div className="col-sm-8">
                                    {/* <input type="email" className="form-control" id="inputEmail" value={input.email} onChange={(e)=>handleChange(e, "email")}/> */}
                                    {/* <input type="email" className="form-control" id="inputEmail" value={input.category} onChange={(e)=>handleChange(e, "category")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Company</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.company} onChange={(e)=>handleChange(e, "company")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.remark} onChange={(e)=>handleChange(e, "remark")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Phone</label>
                                <div className="col-sm-8">
                                    {/* <input type="tel" className="form-control" id="inputTel" pattern="[0-9]{3} [0-9]{3}-[0-9]{4}" value={input.phone} onChange={(e)=>handleChange(e, "phone")}/> */}
                                </div>
                            </div>
                        </div>
                    } 

                    {type === "edit" &&
                        <div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Username</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.username} onChange={(e)=>handleChange(e, "username")}/> */}
                                    <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Password</label>
                                <div className="col-sm-8 d-flex">
                                    {/* <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.password} onChange={(e)=>handleChange(e, "password")}/> */}
                                    {/* <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.type} onChange={(e)=>handleChange(e, "type")}/> */}
                                    <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword" value={input.location} onChange={(e)=>handleChange(e, "location")}/>
                                    <button type="button" className="btn btn-outline-primary mx-1" onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                    </button>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Full Name</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.fullname} onChange={(e)=>handleChange(e, "fullname")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.supplier} onChange={(e)=>handleChange(e, "supplier")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Email</label>
                                <div className="col-sm-8">
                                    {/* <input type="email" className="form-control" id="inputEmail" value={input.email} onChange={(e)=>handleChange(e, "email")}/> */}
                                    {/* <input type="email" className="form-control" id="inputEmail" value={input.category} onChange={(e)=>handleChange(e, "category")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Company</label>
                                <div className="col-sm-8">
                                    {/* <input type="text" className="form-control" id="inputText" value={input.company} onChange={(e)=>handleChange(e, "company")}/> */}
                                    {/* <input type="text" className="form-control" id="inputText" value={input.remark} onChange={(e)=>handleChange(e, "remark")}/> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Phone</label>
                                <div className="col-sm-8">
                                    {/* <input type="tel" className="form-control" id="inputTel" pattern="[0-9]{3} [0-9]{3}-[0-9]{4}" value={input.phone} onChange={(e)=>handleChange(e, "phone")}/> */}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>  

                </div>
            </div>

        </div>
    )
}

export default UsersAddEdit